<template>
  <v-layout class="d-flex flex-column h-screen">
    <v-main :class="containerState" class="d-flex flex-grow-1">
      <v-container
        ref="mainContainerDashboard"
        id="main-container-dashboard"
        fluid
      >
        <v-card id="card_dashboard" class="mx-auto" flat>
          <v-card-text class="pa-0">
            <v-overlay
              v-model="overlay"
              class="align-center justify-center"
              contained
              opacity="1"
              scrim="white"
            >
              <v-progress-circular
                indeterminate
                size="64"
                color="secondary"
              ></v-progress-circular>
            </v-overlay>
          </v-card-text>
          <v-card-text class="pa-0" :opacity="opacityContent">
            <v-row class="flex-nowrap">
              <v-col cols="12" class="mx-1 flex-grow-0 flex-shrink-1">
                <DashboardLayout
                  :containerHeight="containerHeight"
                  :sessionItem="sessionItem"
                  @update-chart-type="updateChartType"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-0" :class="!overlay ? 'd-flex' : 'd-none'">
            <v-btn color="secondary" variant="outlined" @click="abortKpi()">
              {{ $t("labels.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="goBack" variant="elevated">
              {{ $t("labels.back") }}
            </v-btn>
            <v-btn
              color="secondary"
              @click="saveAndContinue()"
              variant="elevated"
            >
              <span v-if="sessionItem.id">{{ $t("labels.update") }}</span>
              <span v-else>{{ $t("labels.continue") }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import AppMixin from "@/mixins/AppMixin.js";
import version from "../version";
import DashboardLayout from "@/components/DashboardLayout.vue";
export default {
  name: "KpiEditorDashboard",
  components: { DashboardLayout },
  mixins: [AppMixin, events, utils],
  props: ["kpimEditorConfig", "realm"],
  data: function () {
    return {
      overlay: true,
      opacityContent: 0,
      appVersion: version,
      languageChangeListener: null,
      sidenavChangeListener: null,
      overlayToggleListener: null,
      containerState: "expanded",
      containerHeight: "0px",
      loggedUserId: "",
      sessionItem: {
        dashboard: {
          chart: {
            type: "bar",
          },
        },
      },
    };
  },
  created() {
    this.overlay = true;
  },
  beforeMount() {
    this.sessionItem = {
      ...this.sessionItem,
      ...JSON.parse(sessionStorage.getItem("kpi")),
    };
  },

  mounted() {
    console.log("Mounted demf-kpi-editor-dashboard v", this.appVersion);
    this.loggedUserId = localStorage.getItem("loggedUserId");

    this.languageChangeListener = (event) => {
      this.setLocale(event.detail.storage);
    };
    document.addEventListener(
      "language-localstorage-changed",
      this.languageChangeListener
    );

    this.sidenavChangeListener = (event) => {
      this.containerState =
        event.detail.storage === "opened" ? "reduced" : "expanded";
    };
    document.addEventListener(
      "sidenav-localstorage-changed",
      this.sidenavChangeListener
    );

    this.$nextTick(() => {
      this.updateContainerHeight(); // Update dimensions
      window.addEventListener("resize", this.updateContainerHeight);
    });
    this.toggleOverlay(false);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateContainerHeight);
    document.removeEventListener(
      "language-localstorage-changed",
      this.languageChangeListener
    );
    document.removeEventListener(
      "sidenav-localstorage-changed",
      this.sidenavChangeListener
    );
  },
  methods: {
    toggleOverlay(value) {
      this.opacityContent = value ? 0 : 1;
      this.overlay = value;
    },
    updateContainerHeight() {
      const element = document.getElementById("main-container-dashboard");
      if (element) {
        const elementCss = window.getComputedStyle(element);
        const paddingTop = parseFloat(
          elementCss.getPropertyValue("padding-top")
        );
        const paddingBottom = parseFloat(
          elementCss.getPropertyValue("padding-bottom")
        );
        this.containerHeight =
          element.offsetHeight - paddingTop - paddingBottom + "px";
      } else {
        console.warn("Not Found: ", element);
      }
    },
    /**
     * Navigate back based on the KPI type stored in `sessionItem.kpiType`.
     * If the KPI type (case-insensitive) is `"manual"`, this redirects to
     * `/editor/definition`; otherwise it redirects to `/editor/formula`.
     * The method attempts to use `this.$router.push(path)` when the Vue
     * Router is available; if navigation fails or the router is not present,
     * it falls back to updating `window.location.href`.
     */
    goBack() {
      // Determine if KPI is Manual. KPI type is stored in `sessionItem.kpiType`.
      const rawType = this.sessionItem?.kpiType || "";
      const isManual = String(rawType).toLowerCase() === "manual";
      const targetPath = isManual ? "/editor/definition" : "/editor/formula";

      // Prefer router navigation when available, otherwise fall back to full reload URL change.
      if (this.$router && typeof this.$router.push === "function") {
        this.$router.push(targetPath).catch(() => {
          // ignore NavigationDuplicated or other navigation errors, fallback to location
          window.location.href = targetPath;
        });
      } else {
        window.location.href = targetPath;
      }
    },
  },
};
</script>
<style scoped>
main.expanded {
  margin-left: 56px;
}
main.reduced {
  margin-left: 256px;
}
main #main-container-dashboard {
  /*ControlPanel total height - toolbar - stepper - Footer*/
  height: calc(100vh - 64px - 104px - 40px);
  overflow-y: auto;
}
@media only screen and (max-height: 768px) {
  main #main-container-dashboard {
    height: calc(100vh - 64px - 104px - 40px);
  }
}
</style>
